import api from './api';

export interface DashboardMetrics {
  totalAreas: number;
  tareasActivas: number;
  totalTareas: number;
  // Registros del rango pedido (fechaInicio/fechaFin), contados en el servidor.
  // Opcionales: ReportesPage arma su propio objeto de métricas sin ellos.
  totalRegistros?: number;
  registrosCompletados?: number;
  registrosHoy: number;
  porcentajeCompletados: number;
  areasPendientes: number;
  areasCompletadas: number;
  areasPorEstado: Array<{
    estado: string;
    cantidad: number;
    porcentaje: number;
  }>;
  registrosSinFinalizar?: number;
  areasUrgentes?: number;
  areasUrgentesDetalle?: Array<{
    areaId: number;
    nombre: string;
    estado: string;
    ultimaLimpieza?: string;
    diasDesdeUltimaLimpieza: number;
  }>;
}

export interface DashboardAlertas {
  registrosSinFinalizar: number;
  areasUrgentes: number;
}

export interface AreaEstado {
  id: number;
  nombre: string;
  estado: string; // Verde | Amarillo | Rojo | Desactivada
  activo: boolean;
  desactivadaManualmente?: boolean;
  ultimaLimpieza?: string | null;
  diasDesdeUltimaLimpieza: number;
  // Ya calculados por el backend (ver EstadoAreaThresholds) - no se recalculan acá.
  minutosRestantesAmarillo?: number | null;
  minutosRestantesRojo?: number | null;
}

export interface PisoEstado {
  pisoId: number;
  pisoNombre: string;
  areas: AreaEstado[];
  totalAreas: number;
  areasVerde: number;
  areasAmarillo: number;
  areasRojo: number;
}

export interface FiltrosDashboard {
  fechaInicio?: string;
  fechaFin?: string;
  usuarioId?: number;
  areaId?: number;
  obra?: string;
}

export const dashboardService = {
  async getMetrics(filtros?: FiltrosDashboard): Promise<DashboardMetrics> {
    const params = new URLSearchParams();
    
    if (filtros?.fechaInicio) params.append('fechaInicio', filtros.fechaInicio);
    if (filtros?.fechaFin) params.append('fechaFin', filtros.fechaFin);
    if (filtros?.usuarioId) params.append('usuarioId', filtros.usuarioId.toString());
    if (filtros?.areaId) params.append('areaId', filtros.areaId.toString());
    if (filtros?.obra) params.append('obra', filtros.obra);

    const response = await api.get(`/dashboard/metrics?${params.toString()}`);
    return response.data;
  },

  async getAlertas(): Promise<DashboardAlertas> {
    const response = await api.get('/dashboard/alertas');
    return response.data;
  },

  async getEstadosPorPiso(): Promise<PisoEstado[]> {
    const response = await api.get('/dashboard/estados-por-piso');
    return response.data || [];
  }
}; 